import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
    onsaheader: {
        background: '#fff',
        padding: '10px',
    },
    onsauserinfo: {
        color: '#53759b',
        float: 'right',
        fontSize: '1.0625rem',
        marginRight: '8%',
        paddingTop: '11px',
    },
    onsaCloseButton: {
        float: 'right',
        paddingTop: '12px',
    },
});
